module.exports = {
  purple: {
    full: '#a464c5',
    tint: '#DBC1E8',
    lightest: '',
  },
  red: {
    full: '#f26046',
    tint: '#FABFB5',
    lightest: '#FDE9E6',
  },
  green: {
    full: '#7abfb4',
    tint: '#D7EBE8',
    lightest: '',
  },
  blue: {
    full: '#4e98da',
    tint: '#B8D6F0',
    lightest: '#E8F1FA',
  },
  grey: {
    full: '#a9a9a9',
    tint: '#dddddd',
    lightest: '#dddddd',
  },
}



// WEBPACK FOOTER //
// ./src/constants/color-map.js